// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RelayRuntime = require("relay-runtime");

let Types = {};

let fragmentConverter = {"__root":{"alertsForCurrentUser_edges_node":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function makeConnectionId(connectionParentDataId) {
  return RelayRuntime.ConnectionHandler.getConnectionID(connectionParentDataId, "AlertsDropdownQuery_alertsForCurrentUser", undefined);
}

function getConnectionNodes(connection) {
  if (connection !== undefined) {
    return Stdlib_Array.filterMap(connection.edges, edge => {
      if (edge !== undefined) {
        return edge.node;
      }
    });
  } else {
    return [];
  }
}

function alertGroup_decode($$enum) {
  if ($$enum === "CONVERSATIONS" || $$enum === "MATCHES") {
    return $$enum;
  }
}

let alertGroup_fromString = alertGroup_decode;

function alertStatus_decode($$enum) {
  if ($$enum === "DISMISSED" || $$enum === "NEW") {
    return $$enum;
  }
}

let alertStatus_fromString = alertStatus_decode;

let Utils = {
  getConnectionNodes: getConnectionNodes,
  alertGroup_decode: alertGroup_decode,
  alertGroup_fromString: alertGroup_fromString,
  alertStatus_decode: alertStatus_decode,
  alertStatus_fromString: alertStatus_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "alertsForCurrentUser"
        ]
      }
    ],
    "throwOnFieldError": true
  },
  "name": "AlertsDropdown_query",
  "selections": [
    {
      "alias": "alertsForCurrentUser",
      "args": null,
      "concreteType": "QueryAlertsForCurrentUserConnection",
      "kind": "LinkedField",
      "name": "__AlertsDropdownQuery_alertsForCurrentUser_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QueryAlertsForCurrentUserConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "grouping",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AlertsDropdownAlertsSection_alerts"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.makeConnectionId = makeConnectionId;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
